<div class="wrapper">
  <div class="yin-yang"></div>
</div>
